var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.addToCartComponent, {
    tag: "component",
    attrs: { item: _vm.item, message: _vm.message },
    on: {
      "product-added-to-cart": function ($event) {
        return _vm.$emit("product-added-to-cart", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }